import { saveAs } from 'file-saver';

import { LotsGetAllResponse, LotsSummary } from '../types/lots';

import { MRT_ColumnFiltersState } from 'mantine-react-table';

import {
  Filters,
  FORM_STATUS,
  formatFilters,
  handleRequest,
  MultisectActionDto,
  privateClient,
} from '@data-access';

export type LotsPrepExportResponse = {
  id: number;
  status: FORM_STATUS;
  instance_id: number;
};

export const lotsApi = {
  getAll: async (filters: Filters) => {
    return handleRequest<LotsGetAllResponse>(
      privateClient
        .get('lots/', {
          searchParams: {
            ...formatFilters(filters),
          },
        })
        .json(),
    );
  },

  getSummary: async (columnFilters: MRT_ColumnFiltersState) => {
    return handleRequest<LotsSummary>(
      privateClient
        .get('lots/summary/', {
          searchParams: {
            ...formatFilters({
              page: 1,
              sorting: [],
              filters: columnFilters,
            }),
          },
        })
        .json(),
    );
  },

  validate: async (id: number) => {
    return handleRequest(
      privateClient
        .patch(`lots/${id}/`, {
          json: {
            is_validated: true,
          },
        })
        .json(),
    );
  },

  prepExport: async (data: MultisectActionDto) => {
    return handleRequest<LotsPrepExportResponse>(
      privateClient
        .post('lots/prep_export/', {
          json: data,
        })
        .json(),
    );
  },

  downloadExport: async (opts: { id: number }) => {
    const res = await handleRequest(
      privateClient.post('lots/export/', {
        json: {
          instance_id: opts.id,
        },
      }),
    );

    const filename =
      res.headers
        .get('content-disposition')
        ?.split(';')
        .find((n) => n.includes('filename='))
        ?.replace('filename=', '')
        .trim() || 'lots-export.xlsx';

    const blob = await res.blob();
    saveAs(blob, filename);

    return res;
  },
};
